import React from 'react'
// import classes from './LoadingSpinner.scss'
import classes from './LoadingSpinner.css'

export const LoadingSpinner = ({ size }) => (
  <div >
      Loading...
  </div>
)

export default LoadingSpinner


// WEBPACK FOOTER //
// ./src/components/LoadingSpinner/LoadingSpinner.jsx